import { scrollToSection } from "@/components/Navbar";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 pt-20 sm:pt-28">
        <div className="grid sm:grid-cols-3 gap-12 pb-20">
          <div>
            <img
              src="/images/opeam-logo-b.png"
              alt="OPEAM Group"
              data-testid="footer-logo"
              className="h-24 w-auto mb-6"
            />
            <p className="text-sm leading-relaxed text-bone/50 max-w-xs">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.35em] uppercase text-copper mb-5">{t.footer.navigate}</p>
            <div className="flex flex-col gap-3">
              {[
                { label: t.nav.whoWeAre, href: "#about", testid: "footer-about-link" },
                { label: t.nav.services, href: "#services", testid: "footer-services-link" },
                { label: t.nav.advantage, href: "#advantage", testid: "footer-advantage-link" },
                { label: t.nav.reviews, href: "#testimonials", testid: "footer-testimonials-link" },
                { label: t.nav.team, href: "#team", testid: "footer-team-link" },
                { label: t.nav.calculator, href: "#calculator", testid: "footer-calculator-link" },
                { label: t.nav.netSheet, href: "#net", testid: "footer-net-link" },
                { label: t.nav.blog, href: "#blog", testid: "footer-blog-link" },
                { label: t.nav.contact, href: "#contact", testid: "footer-contact-link" },
              ].map((l) => (
                <button
                  key={l.href}
                  data-testid={l.testid}
                  onClick={() => scrollToSection(l.href)}
                  className="text-left text-sm text-bone/50 hover:text-copper transition-colors duration-300 w-fit"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs tracking-[0.35em] uppercase text-copper mb-5">{t.footer.reachUs}</p>
            <div className="flex flex-col gap-4 text-sm text-bone/50">
              <div>
                <p className="text-bone/80">Omar Castro</p>
                <a href="tel:6027487239" className="hover:text-copper transition-colors duration-300">602-748-7239</a>
                <span className="mx-2 text-bone/20">·</span>
                <a href="mailto:ocastro@pricemortgage.com" className="hover:text-copper transition-colors duration-300 break-all">ocastro@pricemortgage.com</a>
              </div>
              <div>
                <p className="text-bone/80">Paula Castro</p>
                <a href="tel:6023732882" className="hover:text-copper transition-colors duration-300">(602) 373-2882</a>
                <span className="mx-2 text-bone/20">·</span>
                <a href="mailto:paulacastroazrealtor@gmail.com" className="hover:text-copper transition-colors duration-300 break-all">paulacastroazrealtor@gmail.com</a>
              </div>
              <div>
                <p className="text-bone/80">{t.footer.serviceArea}</p>
                <span>{t.footer.area}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none px-2 -mb-[3vw]" aria-hidden="true">
        <span className="block font-display uppercase leading-[0.78] text-center text-[19vw] text-outline">
          Opeam
        </span>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-[11px] tracking-[0.15em] uppercase text-bone/30">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Opeam Group. {t.footer.rights}</span>
          <span data-testid="footer-licenses">Omar Castro NMLS #2567826 · Paula Castro AZ DRE #SA674481000</span>
          <span>{t.footer.tagline2}</span>
        </div>
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 pb-5 text-center text-[10px] tracking-[0.15em] uppercase text-bone/25" data-testid="footer-compliance">
          Price Mortgage, LLC NMLS ID #1429043 · HomeSmart LIC: LC506032000
        </div>
      </div>
    </footer>
  );
}
